<template>
  <div class="rs-grouped-button-select">
    <label v-if="label">{{ label }}<sup v-if="required">*</sup></label>
    <div class="d-flex button-group justify-content-between">
      <div
        v-for="option in options"
        :key="option.value"
        class="d-flex button-group-item-wrapper"
      >
        <RsButton
          :variant="value === option.value ? 'secondary-light' : 'border'"
          :class="{
            selected: value === option.value,
            unselected: value !== option.value,
          }"
          :disabled="disabled"
          @click="$emit('input', option.value)"
        >
          {{ option.text }}
        </RsButton>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { PropType, defineComponent } from 'vue';
import { ISelectOption } from '@/shared';

export default defineComponent({
  name: 'RsFormGroupedButtonSelect',
  props: {
    value: {
      type: String,
      required: true,
    },
    options: {
      type: Array as PropType<ISelectOption[]>,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: this.value,
    };
  },
});
</script>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';
.rs-grouped-button-select {
  margin-bottom: 1rem;

  .unselected {
    color: $medium-grey;
  }
  .button-group-item-wrapper {
    flex-grow: 1;
    .rs-button {
      display: flex;
      flex-grow: 1;
      &--disabled.selected {
        background-color: $secondary-color;
        color: $white;
      }
    }
    &:first-child .rs-button {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    &:last-child .rs-button {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    &:not(:first-child):not(:last-child) .rs-button {
      border-radius: 0;
    }
  }
}
</style>
